<template>
  <div class="spare-table">
    <!-- <h3>{{ $t('message.selectProduct') }}:</h3> -->
    <table class="table table-striped">
      <thead>
        <tr>
          <th>N.</th>
          <th>{{ $t('message.product') }}</th>
          <th class="spare-price">{{ $t('message.pricePerUnit') }}</th>
          <th>{{ $t('message.qty') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(part, index) in parts" :key="index">
          <td>{{ part.figNo }}</td>
          <td>
            <span class="spare-name">{{ part.name }}</span>
            <br />
            <span class="spare-sku">{{ part.SKU }}</span>
            <div v-if="part.avc" class="avc-status">
              <span :class="`dot-${part.avc_status}`"></span>
              <span class="avc-info">
                <span v-if="part.avc_status == 1">{{
                  $t('message.available')
                }}</span>
                <span v-if="part.avc_status == 2"
                  >{{ $t('message.availableFrom') }} {{ part.avc_ETA }}</span
                >
                <span v-if="part.avc_status == 0">{{
                  $t('message.notAvailable')
                }}</span>
              </span>
            </div>
          </td>
          <td v-if="part.price" class="spare-price">
            <span :class="{ 'spare-price-old': part.priceSale }"
              >{{ part.price }}&nbsp;€</span
            >
            <span class="spare-price-new" v-if="part.priceSale">
              <br />
              {{ part.priceSale }}€
            </span>
          </td>
          <td v-else>-</td>
          <td v-if="part.price" class="qty-row">
            <div class="input-group">
              <input
                type="text"
                class="form-control input-qty"
                v-model="part.qty"
              />
              <div class="input-group-btn">
                <button
                  @click="buy(part)"
                  class="dl_add_to_cart btn"
                  :class="`btn-action-${brand}`"
                  :disabled="part.qty <= 0"
                  :data-sku="part.SKU"
                  :data-brand="brand"
                >
                  <img
                    class="buy-icon"
                    src="https://teilecdn.com/assets/icons/add.svg"
                  />
                  <div
                    v-if="avcNative == false && avcLive == false"
                    style="display: inline"
                  >
                    {{ $t('message.checkAvailability') }}
                  </div>
                  <div v-else style="display: inline">
                    {{ $t('message.buy') }}
                  </div>
                </button>
              </div>
            </div>
          </td>
          <td v-else class="qty-row">
            <button
              class="btn"
              :class="`btn-action-${brand}`"
              style="width: 100%"
              disabled
            >
              <img
                class="buy-icon"
                src="https://teilecdn.com/assets/icons/add.svg"
              />
              {{ $t('message.notAvailable') }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SpareTable',
  computed: {
    avcNative: {
      get() {
        return this.$store.state.avcNative;
      },
    },
    avcLive: {
      get() {
        return this.$store.state.avcLive;
      },
    },
    parts: {
      get() {
        return this.$store.state.parts;
      },
    },
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
  },
  methods: {
    ...mapActions(['buy']),
  },
};
</script>
